import {Component, Inject} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';
import {FlexLayoutModule} from 'ngx-flexible-layout';

@Component({
  selector: 'app-pending-draft-snackbar',
  imports: [
    FlexLayoutModule,
    MatButton,
    MatIcon
  ],
  templateUrl: './pending-draft-snackbar.component.html',
  styleUrl: './pending-draft-snackbar.component.scss',
})
export class PendingDraftSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<PendingDraftSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { title: string, message: string, showContinue?: boolean }
  ) {}

  onContinue() {
    this.snackBarRef.dismissWithAction();
  }

  onClose() {
    this.snackBarRef.dismiss();
  }
}
